import { cn } from '@/lib/utils';
import {
  SEGMENT_ACTIVE_CLASS,
  SEGMENT_BASE_CLASS,
  SEGMENT_INACTIVE_CLASS,
  SEGMENTED_TRACK_CLASS,
} from '@/styles/segmentedControl';
import { MAP_ON_LABELS, MAP_ON_OPTIONS, type MapOn } from '../constants/moTravel.constants';

interface MapOnSwitchProps {
  value: MapOn;
  onChange: (value: MapOn) => void;
  className?: string;
}

export function MapOnSwitch({ value, onChange, className }: MapOnSwitchProps) {
  return (
    <div
      role="group"
      aria-label="Map on"
      className={cn('flex h-10 items-center gap-0.5 sm:h-9', SEGMENTED_TRACK_CLASS, className)}
    >
      {MAP_ON_OPTIONS.map((option) => {
        const isSelected = value === option;
        return (
          <button
            key={option}
            type="button"
            aria-pressed={isSelected}
            onClick={() => onChange(option)}
            className={cn(
              'h-full flex-1 px-3 text-xs sm:flex-none',
              SEGMENT_BASE_CLASS,
              isSelected ? SEGMENT_ACTIVE_CLASS : SEGMENT_INACTIVE_CLASS,
            )}
          >
            {MAP_ON_LABELS[option]}
          </button>
        );
      })}
    </div>
  );
}
